import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import { RouterModule } from '@angular/router'
import { MbSearchBoxComponent } from './mb-search-box.component'
import { MediaModule } from '@spartacus/storefront'
import { UrlModule } from '@spartacus/core'
import { AnalyticsModule } from '../../../analytics/analytics.module'
import { DirectiveModule } from '../../directive.module'

@NgModule({
  declarations: [
    MbSearchBoxComponent
  ],
  imports: [
    CommonModule,
    MbI18nModule,
    RouterModule,
    MediaModule,
    UrlModule,
    AnalyticsModule,
    DirectiveModule
  ],
  exports: [
    MbSearchBoxComponent
  ]
})
export class MbSearchBoxModule {}
